import Vue from 'vue'
import App from './App'
import router from './router';
import store from './store/store';
import axios from 'axios';
import './gtm'

Vue.config.productionTip = false;
Vue.prototype.$resourcesUrl = process.env.BACKEND_URL;
Vue.prototype.$apiUrl = process.env.BACKEND_URL + process.env.API;
Vue.prototype.$supplier = process.env.SUPPLIER;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
  created() {
    this.$store.subscribe((mutation, state) => {
      sessionStorage.setItem('store', JSON.stringify(state));
    });

    // SET WORDING
    axios.get(this.$apiUrl + '/startup-data')
      .then((response) => {
        this.$store.dispatch('SET_SUPPLIER', Object.assign(response.data.data.supplierInfo, this.$supplier));
        this.$store.dispatch('SET_WORDING', response.data.data.wording);
        this.$store.dispatch('SET_MAX_PANELS', response.data.data.supplierInfo);
      })
      .catch(function (error) {
      });
  },
})



// WEBPACK FOOTER //
// ./src/main.js